import apiClient from "../../app/apiClient";

export const projectUpdatesApi = {
  create: (projectId, { title, description, updateDate }, files = []) => {
    const body = new FormData();
    body.append("title", title.trim());
    body.append("description", description.trim());
    body.append("updateDate", updateDate);
    files.forEach((file) => body.append("files", file));
    return apiClient.post("/admin/project/" + encodeURIComponent(projectId) + "/project-update", body, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  list: async (projectId) => {
    const { data } = await apiClient.get("/admin/project/" + encodeURIComponent(projectId) + "/project-updates");
    const updates = Array.isArray(data) ? data : data?.updates ?? data?.data;
    if (!Array.isArray(updates)) throw new Error("The server returned an invalid update list.");
    return updates;
  },
};
